import TextCreate from 'core/display/simple/Text'
import { LocalizationService } from 'services/LocalizationService'

export default class AutoLimitOptionText extends TextCreate{
  constructor(data) {
    super(data)
    const [id, count] = data.name.split('-')
    const autoplayValue = game.models.AutoLimitModel.getAutoLimits(id)[count]
    this.text._style._fontSize = 15
    this.update(Number.isFinite(autoplayValue)
      ? `${autoplayValue} x ${LocalizationService.get(data.text)}`
      : LocalizationService.get(data.text),
    )
  }
}
